import { RegisteredComponent } from "@builder.io/sdk-react";

export const textualFormConfig: RegisteredComponent["inputs"] = [
  {
    name: "variant",
    type: "enum",
    localized: false,
    required: true,
    defaultValue: "form",
    enum: [
      {
        label: "Form",
        value: "form",
        helperText: "Rendering usually used for registration forms.",
      },
      {
        label: "Large round",
        value: "large-round",
        helperText: "Only supported by Search Input.",
      },
      {
        label: "Round",
        value: "round",
      },
      {
        label: "Large rectangular",
        value: "large rectangular",
        helperText: "Only supported by Select.",
      },
      {
        label: "Rectangular",
        value: "rectangular",
      },
      {
        label: "Numeric",
        value: "numeric",
        helperText: "Only supported by Generic Input of type number.",
      },
      {
        label: "Unstyled",
        value: "unstyled",
      },
    ],
  },
  {
    name: "label",
    type: "string",
    localized: true,
    required: false,
    defaultValue: {
      "@type": "@builder.io/core:LocalizedValue",
      Default: "Label",
    },
  },
  {
    name: "placeholder",
    type: "string",
    localized: true,
    required: false,
  },
  {
    name: "invalid",
    friendlyName: "Has error",
    type: "boolean",
    localized: false,
  },
  {
    name: "invalidText",
    friendlyName: "Error message",
    type: "string",
    localized: true,
    required: false,
  },
];
